export const ENCRYPT_KEY = 'ENCRYPT_KEY'
